import { render, staticRenderFns } from "./TemplateDynamicView.vue?vue&type=template&id=068494c6&scoped=true&"
import script from "./TemplateDynamicView.vue?vue&type=script&lang=js&"
export * from "./TemplateDynamicView.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDynamicView.vue?vue&type=style&index=0&id=068494c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068494c6",
  null
  
)

export default component.exports